import script from "./Benefit.vue?vue&type=script&setup=true&lang=js"
export * from "./Benefit.vue?vue&type=script&setup=true&lang=js"

import "./Benefit.vue?vue&type=style&index=0&id=a7e338a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7e338a0"]])

export default __exports__